<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->
    <BreadCrumb :data="breadcrumb" :title="'竞赛详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <DIV v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgBox">
          <img
            v-if="competitionDetail.cover_image"
            :src="competitionDetail.cover_image"
            alt=""
            class="form-content-img logo"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img cover"
          />

          <img
            v-if="competitionDetail.detail_image"
            :src="competitionDetail.detail_image"
            alt=""
            class="form-content-img cover"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img cover"
          />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名</h4>
            <span>{{ competitionDetail.chinese_name }}</span>
          </li>
          <li class="exclusive">
            <h4>英文名</h4>
            <span>{{ competitionDetail.english_name }}</span>
          </li>

          <li class="half">
            <h4>组织</h4>
            <span v-if="competitionDetail.host_organization != null">{{
              competitionDetail.host_organization
            }}</span>
            <span v-if="competitionDetail.host_organization == null">暂无</span>
          </li>
          <li class="half">
            <h4>参赛代号</h4>
            <span v-if="competitionDetail.competition_code != null">{{
              competitionDetail.competition_code
            }}</span>
            <span v-if="competitionDetail.competition_code == null">暂无</span>
          </li>
          <li class="half">
            <h4>参赛状态</h4>
            <span v-if="competitionDetail.competition_status">{{
              competitionDetail.competition_status.chinese_name
            }}</span>
            <span v-if="competitionDetail.competition_status == null"
              >暂无</span
            >
          </li>
          <li class="half">
            <h4>参赛状态</h4>
            <span v-if="competitionDetail.classification">{{
              competitionDetail.classification.chinese_name
            }}</span>
            <span v-if="competitionDetail.classification == null">暂无</span>
          </li>
          <li class="half">
            <h4>创建时间</h4>
            <span v-if="competitionDetail.create_time != null">{{
              competitionDetail.create_time
            }}</span>
            <span v-if="competitionDetail.create_time == null">暂无</span>
          </li>
          <li class="half">
            <h4>开始时间</h4>
            <span v-if="competitionDetail.start_time != null">{{
              competitionDetail.start_time
            }}</span>
            <span v-if="competitionDetail.start_time == null">暂无</span>
          </li>
          <li class="half">
            <h4>结束时间</h4>
            <span v-if="competitionDetail.end_time != null">{{
              competitionDetail.end_time
            }}</span>
            <span v-if="competitionDetail.end_time == null">暂无</span>
          </li>
          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="competitionDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </DIV>
    <div v-show="isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <UploadImage
            :img="competitionDetail.cover_image"
            :width="248"
            :height="178"
            @getUploadImage="getUploadCoverImage"
          ></UploadImage>
          <br /><br />
          <UploadImage
            :img="competitionDetail.detail_image"
            :width="248"
            :height="178"
            @getUploadImage="getUploadDetailImage"
          ></UploadImage>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文标题<span>*</span></h4>
            <el-input
              v-model="competitionDetail.chinese_name"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文标题<span>*</span></h4>
            <el-input
              v-model="competitionDetail.english_name"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>主办方</h4>
            <el-input
              v-model="competitionDetail.host_organization"
              placeholder="请输入主办方"
            ></el-input>
          </li>
          <li class="half">
            <h4>当前阶段</h4>
            <el-select
              v-model="competitionDetail.competition_status"
              clearable
              placeholder="选择阶段"
              class="tag"
              value-key="chinese_name"
            >
              <el-option
                v-for="(item, index) in competitionStatusList"
                :key="index"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>
          <li class="half">
            <h4>竞赛代号</h4>
            <el-input
              v-model="competitionDetail.competition_code"
              placeholder="请输入竞赛代号"
            ></el-input>
          </li>
          <li class="one-third">
            <h4>竞赛分类</h4>
            <el-select
              v-model="competitionDetail.classification"
              placeholder="选择分类"
              class="tag"
              value-key="chinese_name"
            >
              <el-option
                v-for="(item, index) in classificationList"
                :key="index"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>
          <li class="one-third">
            <h4>开始时间</h4>
            <el-date-picker
              v-model="competitionDetail.start_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </li>
          <li class="one-third">
            <h4>结束时间</h4>
            <el-date-picker
              v-model="competitionDetail.end_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </li>
          <li v-show="isEditting" class="button">
            <el-button @click="review1()">一轮评审设置 </el-button>
          </li>
          <li v-show="isEditting" class="button">
            <el-button @click="review2()">二轮评审设置 </el-button>
          </li>
          <li v-show="isEditting" class="button">
            <el-button @click="review3()">三轮评审设置 </el-button>
          </li>
          <li class="one-third"></li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="competitionDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
      <br />
      <div class="form-content-footer">
        <el-button class="button" @click="exportWork()">导出作品</el-button>
        <el-button class="button1" @click="viewDetail()"> 查看作品 </el-button>
      </div>
    </div>
    <CompetitionReview
      v-show="config_type && isEditting == true"
      :config_type="config_type"
      :competitionDetail="competitionDetail"
    />
    <div class="pc-dataDetail-tags">
      <h2>竞赛标签</h2>
      <div class="input" v-if="isEditting">
        <keywordsinput
          :maxLen="18"
          v-model="competitionDetail.tags"
        ></keywordsinput>
      </div>
      <div v-else class="show">
        <p v-for="(tag, index) in competitionDetail.tags" :key="index">
          {{ tag }}
        </p>
      </div>
    </div>
    <div class="detail-form-information">
      <h2>竞赛简介</h2>
      <EditWithTranslator
        ref="richText"
        :englishText="competitionDetail.english_introduce"
        :chineseText="competitionDetail.chinese_introduce"
        :title="competitionDetail.chinese_name"
        :isEditting="isEditting"
      />
    </div>
    <SaveGroup
      class="saveGroup"
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
    <div v-if="this.$route.query.method != 'add'">
      <h2>竞赛详细设置</h2>
    </div>

    <CompetitionCount v-if="this.$route.query.method != 'add'" />
    <CompetitionCommittee v-if="this.$route.query.method != 'add'" />
    <CompetitionRichText v-if="this.$route.query.method != 'add'" />
    <CompetitionPrize
      v-if="this.$route.query.method != 'add'"
      :competitionDetail="competitionDetail"
    />
    <CompetitionTrack
      v-if="this.$route.query.method != 'add'"
      :competitionDetail="competitionDetail"
    />
    <CompetitionField
      v-if="this.$route.query.method != 'add'"
      :competitionDetail="competitionDetail"
    />
    <CompetitionPerson v-if="this.$route.query.method != 'add'" />
    <CompetitionFile v-if="this.$route.query.method != 'add'" />
  </div>
</template>
<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import UploadImage from "../../componentSet/uploadImage.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import CompetitionCommittee from "./components/CompetitionCommittee.vue";
import CompetitionReview from "./components/CompetitionReview.vue";
import CompetitionPrize from "./components/CompetitionPrize.vue";
import CompetitionTrack from "./components/CompetitionTrack.vue";
import CompetitionField from "./components/CompetitionField.vue";
import CompetitionCount from "./components/CompetitionCount.vue";
import CompetitionPerson from "./components/CompetitionPerson.vue";
import CompetitionFile from "./components/CompetitionFile.vue";
import CompetitionRichText from "./components/CompetitionRichText.vue";
import EditWithTranslator from "../../componentSet/EditWithTranslator.vue";
import {
  competitionDetail_Api,
  competitionStatus_Api,
  createCompetitionDetail_Api,
  updateCompetitionDetail_Api,
  competitionClassification_Api,
  outputCompetitionWorks_Api,
} from "@/apis/competition.api";
export default {
  components: {
    UploadImage,
    BreadCrumb,
    SaveGroup,
    CompetitionCommittee,
    CompetitionReview,
    CompetitionPrize,
    CompetitionField,
    CompetitionRichText,
    EditWithTranslator,
    CompetitionCount,
    CompetitionPerson,
    CompetitionFile,
    CompetitionTrack,
  },
  computed: {
    breadcrumb: function() {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "竞赛列表", link: "/admin/newCompetitionList" },
        {
          name: `${
            this.competitionDetail.chinese_name
              ? this.competitionDetail.chinese_name
              : ""
          }`,
          link: "/admin/newCompetitionDetail",
        },
      ];
    },
  },
  data() {
    return {
      isEditting: false,

      isUpdateShow: false,
      competitionDetail: {
        id: null,

        competition_status: {
          chinese_name: "",
        },
      },
      config_type: "",
      classification: {},
      competitionStatusList: [],
      competitionFieldList: [],
      organizationList: [],
      competitionPersonList: [],
      competitionFileList: [],
      classificationList: [],
      competition_status_id: null,
      chinese_detail: "",
      english_detail: "",
      RichTextDetail: {
        content: "",
        text_id: null,
      },
    };
  },
  filters: {
    authorName: function(val) {
      val.forEach((element) => {
        console.log(element);
      });
    },
  },
  created() {},
  mounted() {
    if (this.$route.query.method == "update") {
      this.competitionDetail.id = this.$route.query.id;
      console.log(this.competitionDetail.id);
      this.getCompetitionDetail();
    } else {
      this.isEditting = true;
    }
    competitionStatus_Api().then((res) => {
      this.competitionStatusList = res.data;
      console.log(this.competitionStatusList);
    });
    competitionClassification_Api().then((res) => {
      this.classificationList = res.data;
      console.log(res);
    });
  },

  methods: {
    exportWork() {
      outputCompetitionWorks_Api({
        competition_id: +this.$route.query.id,
      }).then((res) => {
        this.$global.downloadFile(res, "competitionWorkList");
      });
    },
    getCompetitionDetail(hint) {
      competitionDetail_Api(this.competitionDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.competitionDetail = res.data;
        console.log(this.competitionDetail);
      });
    },
    viewDetail() {
      let route = this.$router.resolve({
        path: "/admin/newCompetitionWork",
        query: { id: this.$route.query.id },
      });
      window.open(route.href, "_blank");
    },
    addRichText() {
      this.isUpdateShow = true;
    },
    submitBanner() {},
    review1() {
      this.config_type = "review_r1";
    },
    review2() {
      this.config_type = "review_r2";
    },
    review3() {
      this.config_type = "review_r3";
    },
    changeTag(item) {
      this.selectedTag = item;
      this.getMagazineRichTextDetail(item);
    },
    // returnTranslate(data, flag) {
    //   flag == 1
    //     ? (this.competitionDetail.english_introduce = data)
    //     : (this.competitionDetail.chinese_introduce = data);
    //   console.log(data);
    //   console.log(flag);
    // },
    handleSelect(item) {
      this.competitionDetail.classification = item;
    },

    searchUniversity(queryString, callback) {},
    getUploadCoverImage(img_url) {
      this.competitionDetail.cover_image = img_url;
    },
    getUploadDetailImage(img_url) {
      this.competitionDetail.detail_image = img_url;
    },

    // save group 回调函数
    cancelUpdate() {
      this.getCompetitionDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getCompetitionDetail("恢复成功");
    },
    view() {
      window.open(
        "http://wupen.org/competition/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.competitionDetail);
      if (!formattedData) {
        return;
      } else {
        delete this.competitionDetail.create_time;
        createCompetitionDetail_Api(formattedData)
          .then((res) => {
            this.competitionDetail.id = res.data.id;
            this.isEditting = false;
            this.getCompetitionDetail();
            this.$router.push({
              path: "/admin/newCompetitionDetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.competitionDetail);
      if (!formattedData) {
        return;
      } else {
        delete this.competitionDetail.create_time;
        updateCompetitionDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getCompetitionDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    // 点击编辑
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验
      if (!formData.chinese_name || !formData.english_name) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }
      if (formData.competition_status) {
        formData.competition_status_id = formData.competition_status.id;
      }
      if (formData.classification) {
        formData.classification_id = formData.classification.id;
      }
      formData.chinese_introduce = this.$refs.richText.getContent1();
      formData.english_introduce = this.$refs.richText.getContent();
      console.log(this.competitionInfoDetail);
      formData.competition_id = formData.id;
      formData.keywords = formData.tags;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.saveGroup {
  margin-bottom: 200px;
}
.pc-competition-introduce {
  @include box-model;
}
/deep/ .keywordsTag {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}
.form-content {
  margin-bottom: 20px;
  .imgBox {
    display: flex;
    flex-direction: column;
    .logo {
      width: 248px;
      height: 178px;
      object-fit: contain;
    }
    .cover {
      width: 248px;
      height: 178px;
      object-fit: contain;
    }
  }
}
.form-content-footer {
  display: flex;
  padding: 10px 0 0 0;
  border-top: 1px solid rgb(131, 123, 123);
  height: 50px;
  position: relative;
  .button {
    position: absolute;
    right: 10%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100px;
    height: 40px;
    background: #d9e0ff;
    color: #6b7bcd;
  }
  .button1 {
    position: absolute;
    right: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100px;
    height: 40px;
    background: #d9e0ff;
    color: #6b7bcd;
  }
}
.button {
  margin-right: 20px;
  line-height: 40px;
  margin: 0 auto 20px;

  .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 40px;
    margin-left: 50px;
    background: rgb(217, 224, 255);
    color: rgb(107, 123, 205);
  }
}
.imgBox .form-content-img {
  width: 100%;
  height: 100%;
}
.no-img {
  width: 200px !important;
  height: 150px !important;
}
/deep/ .keywordsTag {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/competition/NewCompetitionDetail.vue